<div class="d-flex">
	<div class="mx-auto h1 access-code-entered-value">
		{{ accessCodeEntered }}
	</div>
</div>
<div class="d-flex flex-wrap">
	<ng-container *ngFor="let num of [1, 2, 3, 4, 5, 6, 7, 8, 9, 'c', 0, 'ok']">
		<div class="w-33">
			<p-button pRipple *ngIf="num !== 'c' && num !== 'ok'" styleClass="p-button-raised p-button-info access-code-button" (click)="addCode(num)">
				<ng-template pTemplate="content">
					<div *ngIf="num !== 'c' && num !== 'ok'" class="h1 d-flex mx-auto">{{ num }}</div>
					<fa-icon *ngIf="num === 'c'" [icon]="['far', 'undo-alt']" size="3x" class="d-flex mx-auto"></fa-icon>
					<fa-icon *ngIf="num === 'ok'" [icon]="['far', 'sign-in']" size="3x" class="d-flex mx-auto"></fa-icon>
				</ng-template>
			</p-button>
			<p-button pRipple *ngIf="num === 'c'" styleClass="p-button-raised p-button-warning access-code-button" (click)="clearCode()">
				<ng-template pTemplate="content">
					<div *ngIf="num !== 'c' && num !== 'ok'" class="h1 d-flex mx-auto">{{ num }}</div>
					<fa-icon *ngIf="num === 'c'" [icon]="['far', 'undo-alt']" size="3x" class="d-flex mx-auto"></fa-icon>
					<fa-icon *ngIf="num === 'ok'" [icon]="['far', 'sign-in']" size="3x" class="d-flex mx-auto"></fa-icon>
				</ng-template>
			</p-button>
			<p-button pRipple *ngIf="num === 'ok'" styleClass="p-button-raised p-button-success access-code-button" (click)="logIn()">
				<ng-template pTemplate="content">
					<fa-icon *ngIf="num === 'ok'" [icon]="['far', 'sign-in']" size="3x" class="d-flex mx-auto"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</ng-container>
</div>
